// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3J-We","filesListContainer":"PosDisputesFiles_filesListContainer__1G1nn","filesButton":"PosDisputesFiles_filesButton__FZWnX"};